import TaskTemplatesCache from './TaskTemplatesCache';
const TaskTemplatesCollection = {
  get allTemplates() {
    return TaskTemplatesCache.list;
  },

  setTemplates(templates) {
    TaskTemplatesCache.updateTemplates(templates);
  },

  add(template) {
    if (this.isValidTemplate(template)) {
      const allTemplates = [...TaskTemplatesCache.list, template];
      TaskTemplatesCache.updateTemplates(allTemplates);
    }
    return TaskTemplatesCache.list;
  },

  edit(template) {
    if (this.isValidTemplate(template)) {
      TaskTemplatesCache.updateSingleTemplate(template);
    }
    return TaskTemplatesCache.list;
  },

  remove(templateId) {
    TaskTemplatesCache.removeSingleTemplate(templateId);
    return TaskTemplatesCache.list;
  },

  findById(templateId) {
    return TaskTemplatesCache.dict?.[templateId];
  },

  findByTitle(query) {
    const queryLowercase = query.toLowerCase().trim();
    return TaskTemplatesCache.list.filter(({ title }) =>
      title.toLowerCase().includes(queryLowercase)
    );
  },

  isValidTemplate(template) {
    return Boolean(
      typeof template === 'object' &&
        template !== null &&
        typeof template.title === 'string' &&
        template.title.length
    );
  },

  clearCache() {
    TaskTemplatesCache.clear();
  },
};

export default TaskTemplatesCollection;
